import logo from './stat.svg';
import './App.css';
import Navbar from './Navbar';

function App() {
  return (
    
    <div className="App">
      <Navbar/>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1> CORE COMPUTER PRODUCTS PVT. LTD.</h1>
      </header>
      
    </div>
    
  
  );
}

export default App;
